import React from 'react'
import { graphql, Link } from 'gatsby'
import {getPageUrl} from '../lib/helpers'

import * as styles from './article-wrapper.module.css'

const ArticleWrapper = ({article, children}) => {
  return (
        <div className={styles.root}>
            <div className={styles.main}>{children}</div>
            <div className={styles.rightPanel}>
              <div className={styles.stickableArea}>
                <div className={styles.stickyMenu}>
                  <div className={styles.adSpace300x}>Advertisement</div>
                  <div className={styles.adSpace250x}>Advertisement</div>
              
                  { article.keyphrases && article.keyphrases.length > 0 &&
                  <div>
                    <p className={styles.rightSubmenu}>Related Topics</p>
                    <ul className={styles.relatedTopics}>
                    {article.keyphrases.map(topic => topic && (
                        <li key={`topic_${topic.id}`} className={styles.listItem}>
                          {topic.keyphrase}
                        </li>
                    ))}
                    </ul>
                  </div>
                  }

                  { article.related_pages && article.related_pages.length > 0 &&
                  <div>
                    <p className={styles.rightSubmenu}>Similar Pages</p>
                    <ul className={styles.similarPages}>
                    {article.related_pages.map(post => post && (
                        <li key={`similar_${post.id}_${post.slug}`} className={styles.listItem}>
                          <Link to={getPageUrl(post)}>{post.title}</Link>
                        </li>
                    ))}
                    </ul>
                  </div>
                  }

                  <div className={styles.adSpace300x}>Advertisement</div>
                  <div className={styles.adSpace250x}>Advertisement</div>
                </div>
              </div>
            </div>
        </div>
  )
}

export default ArticleWrapper
